import { render, staticRenderFns } from "./UserProfilePictureModal.vue?vue&type=template&id=20d6eeb2&"
import script from "./UserProfilePictureModal.vue?vue&type=script&lang=ts&"
export * from "./UserProfilePictureModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports